import { Demo } from '@/features/end-of-lease/Demo';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/lease/demo')({
    component: LeaseDemoPage,
});

function LeaseDemoPage() {
    return (
        <div className="flex-1 h-full" data-testid="LeaseDemo">
            <div className="container">
                <Demo />
            </div>
        </div>
    );
}
